import {Component, Input, OnInit} from '@angular/core';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {Organizzazione} from '../../../_models/Organizzazione';
import {Subscription} from 'rxjs';
import {AuthenticationService} from '../../../_services/authentication.service';
import {AiChatPanelService} from '../../../_services/ai-chat-panel.service';
import {ContenitoreInfoModalService} from '../../../_services/contenitore-info-modal.service';
import {LicenzeService} from '../../../_services/licenze.service';
import {constants} from '../../../_helpers/constants';

@Component({
  selector: 'app-user-header',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.scss'],
  standalone: false
})
export class UserHeaderComponent implements OnInit {
  @Input() iconName: string;
  @Input() pageTitle: string;
  @Input() count = 0;
  @Input() showSearch = true;
  @Input() showBetaBadge = false;
  @Input() betaTooltip = 'Funzionalità ancora in fase di sviluppo: dati e filtri potrebbero cambiare.';
  @Input() searchLabel = 'Ricerca';
  @Input() showMenuButton = true;
  @Input() backHref?: string;
  @Input() showUserInfo = true;
  @Input() showClock = true;
  // Feature 162: pulsante «Info contenitore», solo dove la pagina lo chiede (interfaccia manuale).
  @Input() showInfoContenitore = false;
  dataOggi = new Date();
  organizzazioneCode = '';
  subscriptions: Subscription;

  constructor(
    private organizzazioniService: OrganizzazioniService,
    public authService: AuthenticationService,
    public aiChatPanel: AiChatPanelService,
    public infoContenitore: ContenitoreInfoModalService,
    private licenseService: LicenzeService) { }

  get isAuthenticated(): boolean {
    return !!this.authService.currentUserValue?.jwtToken;
  }

  get infoContenitoreDisponibile(): boolean {
    return this.licenseService.checkPermesso(constants.MOD_PRO_BASE_BOX);
  }

  ngOnInit() {
    if (this.organizzazioniService.currentOrganizzazioneValue != null) {
      this.organizzazioneCode = this.organizzazioniService.currentOrganizzazioneValue.codice;
    }
    this.subscriptions = this.organizzazioniService.currentOrganizzazione
      .subscribe((_org: Organizzazione) => this.organizzazioneCode = _org ? _org.codice : '');
    setInterval(() => this.dataOggi = new Date(), 10);
  }
}
